import { route_types } from ".";
import { route_names } from ".";
import setup from "../../setup";

/**
 * Representing an app route generator.
 */
class Generator
{
    /**
     * Current generated route.
     * @type {?import("vue-router").RouteConfig}
     */
    route;

    /**
     * Creating new route.
     * @param {import("vue-router").RouteConfig} route
     * @returns {Generator}
     */
    create(route = {})
    {
        if (!route.meta) route.meta = {};
        this.route = route;

        return this;
    }

    /**
     * Getting generated route.
     * @returns {import("vue-router").RouteConfig}
     */
    get()
    {
        return this.route;
    }

    /**
     * Route accessible for authenticated users only.
     * @returns {Generator}
     */
    protected()
    {
        return this.typed(route_types.PROTECTED);
    }

    /**
     * Route accessible for non-authenticated users only.
     * @returns {Generator}
     */
    restricted()
    {
        return this.typed(route_types.RESTRICTED);
    }

    /**
     * Route accessible for all users.
     * @returns {Generator}
     */
    public()
    {
        return this.typed(route_types.PUBLIC);
    }

    /**
     * Route representing account selection.
     * @returns {Generator}
     */
    accounts()
    {
        this.route = {
            ...this.route,
            name: route_names.ACCOUNTS_INDEX,
            path: "/accounts"
        };

        return this.typed(route_types.PROTECTED);
    }

    /**
     * Route representing single account homepage.
     * @returns {Generator}
     */
    account()
    {
        this.route = {
            ...this.route,
            name: route_names.ACCOUNTS_SHOW,
            path: "/accounts/:account"
        };

        return this.typed(route_types.PROTECTED);
    }

    /**
     * Route representing homepage.
     * @returns {Generator}
     */
    homepage()
    {
        this.route = {
            ...this.route,
            name: route_names.HOMEPAGE,
            path: '/',
            redirect: { name: route_names.ACCOUNTS_INDEX }
        }

        return this.typed(route_types.PUBLIC);
    }

    /**
     * Defining route sidebar section.
     * @param {import("./types").RouteSidebarInteface} sidebar_section
     * @returns {Generator}
     */
    sidebar(sidebar_section)
    {
        this.route.meta.sidebar_section = sidebar_section;

        return this;
    }

    /**
     * Defining route title.
     * @param {string} title
     * @returns {Generator}
     */
    title(title)
    {
        this.route.meta.title = title;

        return this;
    }

    /**
     * Defining route layout.
     * @param {import("../../types/generics").Optional<import("../../store/state/types").LayoutStateInterface>} layout
     * @returns {Generator}
     */
    layout(layout)
    {
        this.route.meta.layout = layout;

        return this;
    }

    /**
     * Route as given type.
     * @param {import("./types").RouteAccessTypeInterface} access_type Route type.
     * @returns {Generator}
     * @private
     */
    typed(access_type)
    {
        this.route.meta.access_type = access_type;
        
        return this;
    }
}

export default Generator;
